

import { SmetioCustomerWebsiteSection } from "../../smetioCustomerWebsiteSection.js/v1.0.0/SmetioCustomerWebsiteSection.js";

export class SmetioCustomerWebsiteBusinessLocations extends SmetioCustomerWebsiteSection {

      constructor(data = {}) {


            super(data);

            // this.sectionId = "#smetio-template-locations";
            this.sectionId = "smetio-template-locations";
            this.businessLocationsArray = [];
            this.businessLocations = {};
            this.locationDetailsForMap = [];
            this.map = null;
            this.table = "businessLocations";
            this.appUserInterface = "business";
            this.nextSectionClass = null;
            this.initialMapZoom = 5;

            // this.getHeadingText();

            this.mainClass = "smetio-customer-website-business-locations-" + this.id;
            this.mainAttributes = {
                  id: this.sectionId,
                  class: ["smetio-customer-website-business-locations", this.mainClass],
            };

            this.locationsAndMapDivClass = "smetio-customer-website-locations-and-map-div-" + this.id;
            this.locationsAndMapDivAttributes = {
                  class: ["smetio-customer-website-locations-and-map-div", this.locationsAndMapDivClass],
            };

            this.locationsClass = "smetio-customer-website-locations-" + this.id;
            this.locationsAttributes = {
                  class: ["smetio-customer-website-locations", this.locationsClass],
            };

            this.locationsItemsClass = "smetio-customer-website-locations-items" + this.id;
            this.locationsItemsAttributes = {
                  class: ["smetio-customer-website-locations-items", this.locationsItemsClass],
            };

            this.mapClass = "smetio-customer-website-map-" + this.id;
            this.mapAttributes = {
                  class: ["smetio-customer-website-map", this.mapClass],
            };

            this.mapItemClass = "smetio-customer-website-map-item" + this.id;
            this.mapItemAttributes = {
                  class: ["smetio-customer-website-map-item", this.mapItemClass],
            };

            this.mapViewBtnClass = "smetio-customer-website-map-view-btn-" + this.id;
            this.mapViewBtnAttributes = {
                  class: ["smetio-customer-website-btn", "smetio-customer-website-view-btn", "smetio-customer-website-map-view-btn", this.mapViewBtnClass],
            };

            this.listViewBtnClass = "smetio-customer-website-address-view-btn-" + this.id;
            this.listViewBtnAttributes = {
                  class: ["smetio-customer-website-btn", "smetio-customer-website-view-btn", "smetio-customer-website-address-view-btn", this.listViewBtnClass],
            };

      };


      getBusinessHourStatus(data = {}) {

            let { status, endTime, startTime } = data;

            // status = "closed";
            // startTime = "18:00";
            // endTime = "20:00";

            const openText = this.setTxt({
                  attributes: {},
                  txt: "txt416",
                  type: "html"
            });

            const opensText = this.setTxt({
                  attributes: {},
                  txt: "txt1476",
                  type: "html"
            });

            const closedText = this.setTxt({
                  attributes: {},
                  txt: "txt1447",
                  type: "html"
            });

            const closedForTodayText = this.setTxt({
                  attributes: {},
                  txt: "txt1477",
                  type: "html"
            });

            const currentDate = new Date();
            const currentHour = currentDate.getHours();
            const currentMinutes = currentDate.getMinutes();

            // Function to parse "HH:MM" string to total minutes since midnight
            const parseTimeToMinutes = (time) => {
                  const [hours, minutes] = time.split(":").map(Number);
                  return hours * 60 + minutes;
            };

            // Parse startTime and endTime to minutes
            const startMinutes = parseTimeToMinutes(startTime);
            const endMinutes = parseTimeToMinutes(endTime);
            const currentTotalMinutes = currentHour * 60 + currentMinutes;

            if (status !== "open" || currentTotalMinutes >= endMinutes) return ` <div class="smetio-customer-website-open-or-not-closed">${closedForTodayText}</div> `;

            if (currentTotalMinutes >= startMinutes && currentTotalMinutes < endMinutes) return ` <div class="smetio-customer-website-open-or-not-open">${openText}</div> `;

            return `<div><span class="smetio-customer-website-open-or-not-closed">${closedText}.</span> ${opensText} ${startTime}</div>`;


            // mondayBusinessHours
            // : 
            // {endTime: '20:00', startTime: '09:00', status: 'open'}

      };

      showBusinessLocationDetails(data = {}) {
            const { token } = data;
            console.log("You clicked token 2 ", token);
      };

      zoomMapIn(data = {}) {
            const { token } = data;
            const locationIndex = this.businessLocations[token];
            const location = this.businessLocationsArray[locationIndex];
            const { address } = location;
            const { streetAddress, houseNumber, city, postCode, country, geocode } = address;
            const { latitude, longitude } = geocode;
            // this.map.initMap({locations:this.locationDetailsForMap, center:{latitude, longitude}, zoom:20 });
            this.map.panTo({ latitude, longitude });
            this.map.setZoom(16);
      };

      zoomMapOut() {
            // this.map.initMap({locations:this.locationDetailsForMap });
            this.map.setZoom(this.initialMapZoom);
      };

      async displayBusinessLocations() {

            const extractCdnPathFromOneValueOfSmetioFileInput = (await import(/* webpackPrefetch: true */ "@schaniag/private")).extractCdnPathFromOneValueOfSmetioFileInput;
            const SmetioPhotoAndDescription = (await import(/* webpackPrefetch: true */ "../../smetioPhotoAndDescription/v1.0.0/smetioPhotoAndDescription.js")).SmetioPhotoAndDescription;
            const getDayOfTheWeek = (await import(/* webpackPrefetch: true */ "../../../functions/get/getDayOfTheWeek.js")).getDayOfTheWeek;


            const today = getDayOfTheWeek();
            const toBusinessHour = `${today.toLowerCase()}BusinessHours`;
            if (this.businessLocationsArray.length === 1) this.initialMapZoom = 13;
            if (this.businessLocationsArray.length === 2) this.initialMapZoom = 10;
            if (this.businessLocationsArray.length === 3) this.initialMapZoom = 7;

            for (let i = 0; i < this.businessLocationsArray.length; i++) {

                  // tuesdayBusinessHours

                  const location = this.businessLocationsArray[i];
                  const { name, address, token, websiteMultimedia } = location;
                  const { homePhoto_desktop } = websiteMultimedia || {};
                  const { streetAddress, houseNumber, city, postCode, country, geocode } = address;
                  const { latitude, longitude } = geocode;

                  this.locationDetailsForMap.push({
                        name,
                        latitude,
                        longitude,
                  });

                  const photo = extractCdnPathFromOneValueOfSmetioFileInput(homePhoto_desktop);

                  const toBusinessHourDetails = location[toBusinessHour] || {};
                  const openOrNot = this.getBusinessHourStatus({ ...toBusinessHourDetails });

                  const description = `
                        <div class="smetio-customer-website-description" style="min-width:400px; width:400px;">
                              <h4>${name}</h4>
                              <div class="smetio-customer-website-description-address" >
                                    <div class="smetio-customer-website-description-address-icon"> <i class="smetio-icon smetio-icon-map-pin2"></i></div>
                                    <div class="smetio-customer-website-description-address-text">${streetAddress} ${houseNumber}, ${postCode} ${city}</div>
                              </div>
                              
                              <div class="smetio-customer-website-open-or-not">
                                    ${openOrNot}
                              </div>
                        </div>
                  `;

                  const settings = {
                        orientation: "vertical",
                        boxWidth: "100%",
                        boxMaxWidth: this.totalNumberOfData > 1 ? "400px" : "800px",
                        boxMaxHeight: this.totalNumberOfData > 1 ? "350px" : "700px",
                        boxMinHeight: "350px",
                        boxMargin: "10px",
                        boxPadding: "10px",
                        photoWidth: "100%",
                        photoVPosition: "center",
                        descriptionVPosition: "top",
                  };

                  const smetioPhotoAndDescription = new SmetioPhotoAndDescription({
                        photo,
                        description,
                        // isSelected: option.attributes.selected,
                        ...settings,
                        onClicked: (data = {}) => {
                              console.log("You clicked token ", token);
                              this.zoomMapIn({ token });
                              this.showBusinessLocationDetails({ token });
                        },
                        onMouseEnter: (data = {}) => {
                              console.log("You clicked token ", token);
                              this.zoomMapIn({ token });
                        },
                        onMouseLeave: (data = {}) => {
                              console.log("You clicked token ", token);
                              this.zoomMapOut();
                        },
                  });

                  const businessLocation = smetioPhotoAndDescription.render();

                  if (i < 1) $(`.${this.locationsItemsClass}`).html("");

                  $(`.${this.locationsItemsClass}`).append(businessLocation);

                  this.businessLocations[token] = i;

                  // if(i > 0) break;
                  // break;

            };

            setTimeout(() => {
                  const { dominantColor, accentColor } = this.brandColors;
                  
                  let locationsAndMapDivClassHeight = $(`.${this.locationsItemsClass}`).height();
                  locationsAndMapDivClassHeight = parseInt(locationsAndMapDivClassHeight);
                  // console.log("locationsAndMapDivClassHeight is ",locationsAndMapDivClassHeight);
                  // $(".smetio-customer-website-map").css("height", locationsAndMapDivClassHeight+"px !important");
                  // $(".smetio-customer-website-map").innerHeight(locationsAndMapDivClassHeight);
                  $(`.${this.mapItemClass}`).css("height", locationsAndMapDivClassHeight + "px !important");
                  $(`.${this.mapItemClass}`).innerHeight(locationsAndMapDivClassHeight);
                  // document.getElementById('mapIframId').contentWindow.initMap({locations:this.locationDetailsForMap });
                  this.map.initMap({ locations: this.locationDetailsForMap, zoom:this.initialMapZoom, dominantColor:dominantColor.code, accentColor:accentColor.code });


            }, 400);

      };

      async getBusinessLocations() {

            const funcData = this.getFuncData();

            // this.totalNumberOfData = await this.getTotalNumberOfAvailableData(funcData);

            // console.log("this.totalNumberOfData is ", this.totalNumberOfData);

            const serverMsg = await this.getDataFromServer({ ...funcData, type: "retrieve" });
            this.businessLocationsArray = serverMsg.msg;
            this.totalNumberOfData = this.businessLocationsArray.length;

            console.log("this.businessLocationsArray is ", this.businessLocationsArray);

            this.displayBusinessLocations();


      };

      async display() {

            // const {nextSectionClass} = data;

            await this.getHeadingText();

            $(`.${this.sectionHeadingClass}`).html(this.heading);

            await this.getBusinessLocations();

            // if(nextSectionClass) nextSectionClass.display(data);
            if (this.nextSectionClass) this.nextSectionClass.display();

            const iframe = document.getElementById("mapIframId");

            console.log("iframe is ", iframe);
            this.map = iframe.contentWindow;
      };

      render(data = {}) {

            // this.getHeadingText();
            // await this.setPreloader();

            this.events();

            // setTimeout(() => {

            //   this.display(data);
            //   // // this.smetioPreloader.show();
            //   // this.getBusinessLocations();
            //   // const iframe = document.getElementById('mapIframId');

            //   // console.log("iframe is ",iframe);
            //   // this.map = iframe.contentWindow;
            // }, 100);

            const mapViewText = this.setTxt({
                  attributes: this.mapViewBtnAttributes,
                  txt: "txt1474",
                  type: "title"
            });

            const listViewText = this.setTxt({
                  attributes: this.listViewBtnAttributes,
                  txt: "txt199",
                  type: "title"
            });

            const seeDetailsText = this.setTxt({
                  attributes: {},
                  txt: "txt1475",
                  type: "html"
            });


            // let searchAndFilterBtn = `
            //   <div ${this.getAttributes(this.filterBtnAttributes, false)} >
            //     <i class="smetio-icon smetio-icon-filter1"></i>
            //   </div>    

            //   <div ${this.getAttributes(this.searchBtnAttributes, false)} >
            //     <i class="smetio-icon smetio-icon-search1"></i>
            //   </div>    
            // `;
            let searchAndFilterBtn = this.getSearchAndFilterBtn();
            // <h2 ${this.getAttributes(this.sectionHeadingAttributes, false)} > ${this.heading} </h2>

            return `
        <section ${this.getAttributes(this.mainAttributes, false)}>

          <h2 ${this.getAttributes(this.sectionHeadingAttributes, false)} >  </h2>

          <div ${this.getAttributes(this.locationsAndMapDivAttributes, false)} >

            <div ${this.getAttributes(this.locationsAttributes, false)}>

              <div class="smetio-customer-website-locations-map-instruction"> 

                <h6> ${seeDetailsText} </h6> 

                <div ${this.getAttributes(this.mapViewBtnAttributes, false)} >
                  <i class="smetio-icon smetio-icon-map4"></i>
                </div>

                ${searchAndFilterBtn}

              </div>

              <div ${this.getAttributes(this.locationsItemsAttributes, false)}> 
                ${this.simplePreloader()}
              </div>
        
            </div>

            <div ${this.getAttributes(this.mapAttributes, false)}>

              <div class="smetio-customer-website-locations-map-instruction"> 

                <h6> ${seeDetailsText} </h6> 

                <div ${this.getAttributes(this.listViewBtnAttributes, false)} >
                  <i class="smetio-icon smetio-icon-list"></i>
                </div>

                ${searchAndFilterBtn}

              </div>

              <div ${this.getAttributes(this.mapItemAttributes, false)} >
                <iframe id="mapIframId" src="/map/en" frameborder="0" sandbox="allow-scripts allow-same-origin"></iframe>
              </div>
              
            </div>            

          </div>

        </section>
    `;

      };

/* 
              <div ${this.getAttributes(this.mapItemAttributes, false)} >
                <iframe id="mapIframId" src="${window.defaultPath}map/en?smetio_bnac=${this.smetioBnac}" frameborder="0" sandbox="allow-scripts allow-same-origin"></iframe>
              </div>
*/      

      // checkWindowSize() {

      //   console.log("Checking for desktop *******");

      //   var desktopWidth = 1000;
      //   if (window.innerWidth < desktopWidth) return false;

      //   $("." + this.mapClass).attr("data-smetio-is-visible", true);
      //   $("." + this.locationsClass).attr("data-smetio-is-visible", true);

      //   console.log("Desktop found *******");

      // };

      events() {

            $("body").on("mousedown", "." + this.mapViewBtnClass, () => {

                  $("." + this.mapClass).attr("data-smetio-is-visible", true);
                  $("." + this.locationsClass).attr("data-smetio-is-visible", false);

            });

            $("body").on("mousedown", "." + this.listViewBtnClass, () => {

                  $("." + this.mapClass).attr("data-smetio-is-visible", false);
                  $("." + this.locationsClass).attr("data-smetio-is-visible", true);

            });

            // window.addEventListener('resize', this.checkWindowSize);


      };

};
